var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { AutocompleteChip } from "../../../../Atoms";
var style = { mr: 2, mb: 2 };
var Tags = function (_a) {
    var tags = _a.tags;
    return (_jsx(Stack, __assign({ direction: "row", mt: 1, flexWrap: "wrap" }, { children: tags.map(function (tag) { return (_jsx(AutocompleteChip, { option: __assign({}, tag), sx: style }, tag.id)); }) })));
};
export default Tags;
